import * as Yup from 'yup';

export const ResetServiceOrderSchema = Yup.object().shape({
  reason: Yup.string().required("Kindly enter the reason").max(1024, "Reason is too long"),
})

export const ResetServiceOrderInitialValues = {
  reason: "",
}